"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Popper2 = _interopRequireDefault(require("@material-ui/core/Popper"));

var _Paper2 = _interopRequireDefault(require("@material-ui/core/Paper"));

var _ClickAwayListener2 = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));

var _Grid2 = _interopRequireDefault(require("@material-ui/core/Grid"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ModalColorSelect = function ModalColorSelect(_ref) {
  var id = _ref.id,
      anchorEl = _ref.anchorEl,
      open = _ref.open,
      handleClose = _ref.handleClose,
      title = _ref.title,
      onChange = _ref.onChange;
  var classes = useStyles();
  var color = ["cyan", "green", "blue", "red", "yellow"];

  var handleClick = function handleClick(color) {
    onChange(id, color);
  };

  return /*#__PURE__*/_react["default"].createElement(_Popper2["default"], {
    id: id,
    open: open,
    anchorEl: anchorEl,
    disablePortal: true,
    getcontentanchorel: null,
    role: undefined,
    placement: "bottom-start",
    style: {
      zIndex: 99,
      padding: 0,
      margin: 0,
      cursor: "default"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Paper2["default"], {
    className: classes.paper
  }, /*#__PURE__*/_react["default"].createElement(_ClickAwayListener2["default"], {
    onClickAway: handleClose
  }, /*#__PURE__*/_react["default"].createElement(_Grid2["default"], {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start"
  }, color.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_Grid2["default"], {
      key: index,
      item: true,
      xs: 6
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: classes.button,
      onClick: function onClick() {
        return handleClick(item);
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: classes.span,
      style: {
        backgroundColor: item,
        color: "white"
      }
    }, title)));
  })))));
};

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    paper: {
      border: "1px solid",
      backgroundColor: "white",
      width: 220
    },
    button: {
      cursor: "pointer",
      height: "100%",
      width: "100%",
      border: "none",
      padding: 5,
      backgroundColor: "transparent",
      "&:hover": {
        backgroundColor: "rgba(0,0,0,0.1)"
      }
    },
    span: {
      padding: 5,
      borderRadius: 25,
      maxWidth: "100%",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      display: "inherit",
      overflow: "hidden"
    }
  };
});
ModalColorSelect.defaultProps = {
  handleClose: function handleClose() {},
  onChange: function onChange() {}
};
ModalColorSelect.propTypes = {
  id: _propTypes["default"].string,
  open: _propTypes["default"].bool,
  anchorEl: _propTypes["default"].object,
  handleClose: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  title: _propTypes["default"].string
};
var _default = ModalColorSelect;
exports["default"] = _default;